import log from 'loglevel';
import lang from "../util/lang";

log.setLevel(process.env.REACT_APP_TIER === 'prd' ? 'error' : 'debug')

const initState = {
  caseDescription: '', // For Create a Case
  caseNumber: null,
  contactInfoPage: {
    enableNextButton: false,
  },
  serialNumber: null, // Need to make get calls to get this contract Number
  curPage: 'signInSpinPage',
  hulaResponse: null,
  serialNumberAndProductName: '',
  currentHULADetails: {
    isICAssets: false,
    datalist: [],
    prodList:[],
    releaseList: [],
    authEmail: '',
    isLoading: false, // HULA Serial Number validating(loading) is false initially.
    isSerialNumberValidated: false,
    showClose: false,
    showGreenTick: false,
    serialNumber: null,
    productName: null,
    productKey: null,
    productVersions: {},
    selectedProductVersion: null,
    productVersionKeys: {}, // product version and their keys.
    colName: null, // col Name for product selection field.
    crossGradeProducts: [], // cross grade API call response.
    selectedProduct: null, // when user choose product from product dropdown.
    productKeyMapping: {},
    isUserAdmin: false,      // Authorization page: options.
    suggestedCrosGradeProduct: [],
    loadingMoreThanRequired: false, // to show spin message update.
    storeProductVersion: {},  // backup.
  },
  errors: {
    authEmail: null, // Email not associated with entered Serial Number.
    isMultiUserDeployment: false,  // HL-08 error.
    isHULAEligible: true,
    hulsNotEligible: false,
    isEmailError: null,
    invalidSerialNumber: false,
    crossGradeHula: false,
    isTFLEX: false,
  },
  errorType: null,
  hasAgentLoaded: false,
  hasExtension: false, // Handle 'Have a question?' section is clicked or not
  isAgentAvailable: false, // Handle if chat agent is available
  langStrings: lang.en,
  prevPage: null,
  productInfoPage: {
    checkSerialNumber: false,
    enableSubmitButton: false,
    keepTyping: false,
    serialNumber: null,
    showCheckmark: false,
    showLoadingSpinner: false,

    // added by Archit
    showProductDropdown: false,
    showVersionDropdown: false,
  },
  showForm: {
    showEnteredCM: false, // CM specifically
  },
  caseError: {
    errorMessage: '',
    errorDesc: '',
  },
  user: {
    email: null,
    firstName: null,
    lastName: null,
  },
  widgetName: 'hula',
  isWidgetOpen: true,
  gtmAnalyticsPushed: '',
  expandFooterOnError: false,
};

// eslint-disable-next-line
export let chatDetails;

const lanuageMap = {
  de: 'German',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  pl: 'English', // English
  pt: 'Portuguese Brazillian',
  ru: 'Russian',
  tr: 'English', // English
  zh: 'Chinese (simplified)',
  en: 'English',
};

export const langSelected = 'en'; // Get this value from the website this widget is integrated into
export const availableLangList = [
  'de',
  'es',
  'fr',
  'it',
  'ja',
  'ko',
  'pl',
  'pt',
  'ru',
  'tr',
  'zh',
];

// Get URL parameters
const searchParams = new URLSearchParams(window.location.search)

log.debug('URL object language : ', searchParams.get('language'))
log.debug('URL object language : ', searchParams.get('country'))
// eslint-disable-next-line import/no-mutable-exports
export let aknLangSelected = 'en';
const locale = searchParams.get('language')
// override default language
if (locale === 'pt-br') {
  aknLangSelected = 'pt'
} else if (locale === 'zh-hans') {
  aknLangSelected = 'zh'
} else {
  // eslint-disable-next-line prefer-destructuring
  aknLangSelected = locale
}

// parentUrl for loginWithRedirect retrunTo URL
const parentUrl = searchParams.get('parentUrl') || window.location.href
log.debug('[HULA] parentUrl:', parentUrl)

// ETE2-3504 - Links to widget from AVA use a special suborigin
const isAvaSubOrigin = !!searchParams.get('fromava')

let caseLanguage
Object.keys(lanuageMap).forEach((localLang) => {
  if (localLang === aknLangSelected) {
    caseLanguage = lanuageMap[localLang]
  }
})

export const isRUorJA = aknLangSelected === 'ru' || aknLangSelected === 'ja'
export const countryCode = searchParams.get('country') || 'US'

/**
 * Below case details for open-case.
 */
export const caseDetails = {
  caseArea: 'Registration and Activation',
  description: lang.en.hula.welcome.modalTitle,
  origin: 'Corporate Website',
  subOrigin: isAvaSubOrigin ? 'AVA Case' : 'AKN Case',
  subject: lang.en.hula.welcome.modalTitle,
  caseLanguage,
  systemName: 'VA',
  topic: 'HULA Request or Extension',
  type: 'License Management',
  country: countryCode,
}

/**
 * Below case details for closed-case.
 */
export const caseDefaultDetails = {
  caseArea: 'Registration and Activation',
  description: lang.en.hula.welcome.modalTitle,
  origin: 'Corporate Website',
  subOrigin: isAvaSubOrigin ? 'AVA Transactions' : 'AKN Transactions',
  subject: lang.en.hula.welcome.modalTitle,
  caseLanguage,
  systemName: 'HULA',
  topic: 'HULA Request or Extension',
  type: 'License Management',
}

const siteTier = process.env.REACT_APP_TIER ?? 'prd'

// eslint-disable-next-line import/no-mutable-exports
let siteTierConfig

if (siteTier === 'prd') {
  // PROD
  chatDetails = {
    liveAgentId: '573300000001bHr',
    typeId: '012300000019SXBAA2',
    topic: 'Contract Administration',
    widgetOrigin: 'Corporate Website',
    chatSubOrigin: isAvaSubOrigin ? 'AVA Chats' : 'AKN Chats',
    deploymentUrl:
      'https://c.la1-c2-phx.salesforceliveagent.com/content/g/js/42.0/deployment.js',
    initUrl: 'https://d.la1-c2-phx.salesforceliveagent.com/chat',
    initParamOne: '572300000001aGj',
    initParamTwo: '00D300000008uIL',
  }

  siteTierConfig = {
    button_ids: {
      en: '573300000001bHr', // english
      zh: '573300000001bHp', // Simplified Chinese
      fr: '573300000001bHs', // French
      de: '573300000001bHt', // german
      ja: '573300000001bHv', // japanese
      pl: '573300000001bHr', // polish
      pt: '573300000001bHr', // Brazilian Portuguese
      ru: '573300000001bHr', // Russian
      es: '573300000001bHy', // Spanish
      tr: '573300000001bHr', // Turkish
      it: '573300000001bHu', // Italian
      ko: '573300000001bHw', // Korean
    },
    routerLambdaUrl:
      'https://ppau67awad.execute-api.us-east-1.amazonaws.com/PROD',
  }
} else {
  // DEV and STAGE
  log.setLevel('debug')
  chatDetails = {
    liveAgentId: '573300000001bHr',
    typeId: '012300000019SXBAA2',
    topic: 'Contract Administration',
    widgetOrigin: 'Corporate Website',
    chatSubOrigin: isAvaSubOrigin ? 'AVA Chats' : 'AKN Chats',
    deploymentUrl:
      'https://c.la1-c1cs-ia5.salesforceliveagent.com/content/g/js/52.0/deployment.js',
    initUrl: 'https://d.la1-c1cs-ia5.salesforceliveagent.com/chat',
    initParamOne: '572300000001aGj', // deploymentId
    initParamTwo: '00D2C00000014ds', // orgID
  }
  siteTierConfig = {
    button_ids: {
      en: '573300000001bHr', // english
      zh: '573300000001bHp', // Simplified Chinese
      fr: '573300000001bHs', // French
      de: '573300000001bHt', // german
      ja: '573300000001bHv', // japanese
      pl: '573300000001bHr', // polish
      pt: '573300000001bHr', // Brazilian Portuguese
      ru: '573300000001bHr', // Russian
      es: '573300000001bHy', // Spanish
      tr: '573300000001bHr', // Turkish
      it: '573300000001bHu', // Italian
      ko: '573300000001bHw', // Korean
    },
    routerLambdaUrl:
      'https://xy1e932aff.execute-api.us-east-1.amazonaws.com/STAGE',
  }
}

chatDetails.liveAgentId = siteTierConfig.button_ids[aknLangSelected]

export { parentUrl, siteTierConfig, initState }

